import IncTextField, {
  IncTextFieldProps,
} from 'components/forms/fields/inc-text-field/inc-text-field.component';

const DisplayInformationDescriptionField = (props: IncTextFieldProps) => {
  return <IncTextField multiline rows={5} {...props} />;
};

export default DisplayInformationDescriptionField;
